import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
  name: 'products',
  initialState: {
    selectedProducts: [],
  },
  reducers: {
    addProduct: (state, action) => {
      state.selectedProducts.push(action.payload);
      console.log('Charge utile:', action.payload)
    },
    removeProduct: (state, action) => {
      state.selectedProducts = state.selectedProducts.filter(
        (product) => product.id !== action.payload.id
      );
    },
    clearProducts: (state) => {
      state.selectedProducts = [];
    },
  },
});

export const { addProduct, removeProduct, clearProducts } = productSlice.actions;
export default productSlice.reducer;



// import { createSlice } from '@reduxjs/toolkit';

// const productSlice = createSlice({
//   name: 'products',
//   initialState: {
//     sections: {}, // Chaque clé est un identifiant de section, et la valeur est un tableau de produits.
//   },
//   reducers: {
//     addProduct: (state, action) => {
//       const { sectionId, product } = action.payload;
//       if (!state.sections[sectionId]) {
//         state.sections[sectionId] = [];
//       }
//       // state.sections[sectionId].push(product);
//       if (!state.sections[sectionId].some(p => p.id === product.id)) {
//         state.sections[sectionId].push(product);
//       }
//       console.log('Charge utile:', action.payload);
//     },
//     removeProduct: (state, action) => {
//       const { sectionId, productId } = action.payload;
//       if (state.sections[sectionId]) {
//         state.sections[sectionId] = state.sections[sectionId].filter(
//           (product) => product.id !== productId
//         );
//       }
//     },
//     clearProducts: (state, action) => {
//       const { sectionId } = action.payload;
//       if (state.sections[sectionId]) {
//         state.sections[sectionId] = [...state.sections[sectionId]];
//       }
//     },
//   },
// });

// export const { addProduct, removeProduct, clearProducts } = productSlice.actions;
// export default productSlice.reducer;
